module.exports = __webpack_public_path__ + "media/components/lesson3/common/statics/connectBlock-f6554d5f96d97c607ce69525afec2907.gif";